export class EditQueue{
    crmUserId:number;
    description:string;
    queueEnabled:boolean;
    queueId:number;
    queuePriority:string;
    sessionToken:string;
    sla:number;
}